
import * as React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { OperationalBudget } from "../../../../Common/Services/OperationalBudget";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import _ from "lodash";


const months = [
  { month: "jan", per: "per1", name: "Jan" },
  { month: "feb", per: "per2", name: "Feb" },
  { month: "mar", per: "per3", name: "Mar" },
  { month: "apr", per: "per4", name: "Apr" },
  { month: "may", per: "per5", name: "May" },
  { month: "jun", per: "per6", name: "Jun" },
  { month: "jul", per: "per7", name: "Jul" },
  { month: "aug", per: "per8", name: "Aug" },
  { month: "sep", per: "per9", name: "Sep" },
  { month: "oct", per: "per10", name: "Oct" },
  { month: "nov", per: "per11", name: "Nov" },
  { month: "dec", per: "per12", name: "Dec" },
  { month: "total", per: "total", name: "Total" },
];

const SUBGROUP_TYPES = {
  REVENUE: "Revenue",
  EXPENSE: "Expense",
};

const _arrobj = {
  type: String,
  id: String,
  title: String,
  titlevalue: String,
  factorMethod: String,
  factorValue: Number,
  jan: {},
  feb: {},
  mar: {},
  apr: {},
  may: {},
  jun: {},
  jul: {},
  aug: {},
  sep: {},
  oct: {},
  nov: {},
  dec: {},
  total: {},
  group: String,
  subgroup: String,
  budgetType: String,
  coa: String,
  segmentName: String,
  Groupindex: Number,
};

export class Departments extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      resultData: [],
      filterData: [],
      istableloader: false,
      selectedYear: this.props.selectedYear,
      hidValue: this.props.hidValue,
    };
  }

  componentDidMount(): void {
    this.getDepartmentData();
  }

  getDepartmentData = () => {
    this.setState({ istableloader: true });
    let request: any = {};
    request.Hid = this.props.hidValue;
    request.year = this.props.selectedYear;
    OperationalBudget.GetBudgetDepartment(request).then(
      async (result: any = []) => {
        this.setState({ resultData: result }, () => {
          this.GroupingLogic(result);
        });
      }
    );
  };

  GroupingLogic = (result) => {


    let uniqueGroupName = _.uniqBy(result, "groupName");
    console.log(uniqueGroupName);

    let arrData: any = [];
    uniqueGroupName = _.sortBy(uniqueGroupName, ["srNo"]);
    uniqueGroupName.map((group, Groupindex) => {

      // add Group Row e.g. Room
      let _objgroup = {
        ..._arrobj, ...{
          type: "group",
          id: group.id,
          title: group.groupName,
          titlevalue: "",
          factorMethod: group.factorMethod,
          factorValue: group?.factorValue || 0,
          group: group.groupName,
          subgroup: group.subType,
          budgetType: group.budgetType,
          coa: group.coa,
          segmentName: group.segmentName,
          Groupindex: Groupindex,
        }
      };

      arrData.push(_objgroup);


      let GroupsData = result.filter((e) => e.groupName === group.groupName);
      let Subgroups = _.uniqBy(GroupsData, "subType");
      let subDataArr: any = [];
      Subgroups.map((subgroup, index) => {

        // add SubGroup Row Revenue/Expanse

        let _objsubgroup = {
          ..._arrobj, ...{
            type: "subgroup",
            id: subgroup.id,
            title: subgroup.subType,
            titlevalue: "",
            factorMethod: subgroup.factorMethod,
            factorValue: subgroup?.factorValue || 0,
            group: subgroup.groupName,
            subgroup: subgroup.subType,
            budgetType: subgroup.budgetType,
            coa: subgroup.coa,
            segmentName: subgroup.segmentName,
            Groupindex: Groupindex,
          }
        };

        arrData.push(_objsubgroup);


        let subGroupData = result.filter((e) => e.groupName === subgroup.groupName && e.subType === subgroup.subType);

        let coaData = _.uniqBy(subGroupData, "coa");

        coaData = _.sortBy(coaData, (item) => {
          const parsed = parseFloat(item.coa);
          return isNaN(parsed) ? item.coa : parsed;
        });
        let coaDataArr: any = [];

        coaData.map((coaitem) => {
          let _objcoa: any = {
            type: "item",
            id: coaitem.id,
            title: coaitem.segmentName,
            titlevalue: coaitem.coa,
            factorMethod: coaitem.factorMethod,
            factorValue: coaitem?.factorValue || 0,
            group: coaitem.groupName,
            subgroup: coaitem.subType,
            budgetType: coaitem.budgetType,
            coa: coaitem.coa,
            segmentName: coaitem.segmentName,
            Groupindex: Groupindex,
          };

          // Filter out matching budget types
          let coaData = subGroupData.filter(
            (e) =>
              e.groupName === coaitem.groupName &&
              e.subType === coaitem.subType &&
              e.coa === coaitem.coa
          );

          months.forEach(({ month, per }) => {
            _objcoa[month] = this.createCOAData(coaData, per);
          });

          arrData.push(_objcoa);
          coaDataArr.push(_objcoa);
        });

        // Calculating total Row
        let _objSubGroupTotal = {
          type: "total",
          id: subgroup.id,
          title: `${subgroup.subType} Total`,
          titlevalue: "",
          factorMethod: subgroup.factorMethod,
          factorValue: subgroup?.factorValue || 0,
          group: subgroup.groupName,
          subgroup: subgroup.subType,
          budgetType: subgroup.budgetType,
          coa: subgroup.coa,
          segmentName: subgroup.segmentName,
          Groupindex: Groupindex,
        };

        months.forEach(({ month, per }) => {
          _objSubGroupTotal[month] = this.sumSubgroupTotals(coaDataArr, month);
        });

        arrData.push(_objSubGroupTotal);
        subDataArr.push(_objSubGroupTotal);

      });

      // Calculating Profit Row
      let _objGroupProfit = {
        type: "profit",
        id: group.id,
        title: group.groupName + " Profit",
        titlevalue: "",
        factorMethod: group.factorMethod,
        factorValue: group?.factorValue || 0,
        group: group.groupName,
        subgroup: group.subType,
        budgetType: group.budgetType,
        coa: group.coa,
        segmentName: group.segmentName,
        Groupindex: Groupindex,
      };

      let revenueData = subDataArr.filter((e) => e.subgroup.toLowerCase() == SUBGROUP_TYPES.REVENUE.toLowerCase());
      let expenseData = subDataArr.filter((e) => e.subgroup.toLowerCase() == SUBGROUP_TYPES.EXPENSE.toLowerCase());

      months.forEach(({ month, per }) => {
        _objGroupProfit[month] = this.GetprofitData(revenueData, expenseData, month);
      });

      arrData.push(_objGroupProfit);
    });

    this.setState({ filterData: arrData, istableloader: false });
  };

  // Get Group Profit
  GetprofitData = (revenueData, expenseData, month) => {
    const current = (revenueData[0]?.[month]?.Current || 0) - (expenseData[0]?.[month]?.Current || 0);
    const budget = (revenueData[0]?.[month]?.Budget || 0) - (expenseData[0]?.[month]?.Budget || 0);
    const actual = (revenueData[0]?.[month]?.Actual || 0) - (expenseData[0]?.[month]?.Actual || 0);
    return { Current: current, Budget: budget, Actual: actual };
  };

  // Get COA wise Data
  createCOAData = (coaItems, monthKey) => {
    const current = coaItems.find(e => e.budgetType === 'Current')?.[monthKey] || 0;
    const budget = coaItems.find(e => e.budgetType === 'LY Budget')?.[monthKey] || 0;
    const actual = coaItems.find(e => e.budgetType === 'LY Actual')?.[monthKey] || 0;
    return { Current: current, Budget: budget, Actual: actual };
  };

  //Get Sub Group Total
  sumSubgroupTotals = (dataArr, month) => ({
    Current: dataArr.reduce((sum, e) => sum + (e[month]?.Current || 0), 0),
    Budget: dataArr.reduce((sum, e) => sum + (e[month]?.Budget || 0), 0),
    Actual: dataArr.reduce((sum, e) => sum + (e[month]?.Actual || 0), 0),
  });

  render() {
    const columns = [
      {
        dataField: "",
        text: "",
        headerClasses: "width-150",
        classes: "width-150",
        headerFormatter: (column, colIndex) => {
          return (
            <div>
              COA Name
              <div className="sub-txt">COA #</div>
            </div>
          );
        },

        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div>
              <ul>
                <li className="bold">
                  <EllipsisWithTooltip placement="bottom">
                    {row.title}
                  </EllipsisWithTooltip>
                </li>
                {row.type == "item" && <li>{row.titlevalue}</li>}
              </ul>
            </div>
          );
        },
      },
      {
        dataField: "fectorMethod",
        text: "Factor Method",
        headerClasses: "width-150",
        classes: "width-150 factor-method",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div>
              {row.type == "item" && (
                <ul
                  className={
                    row.titlevalue == "Multi"
                      ? "badge color-gray"
                      : "badge color-green"
                  }
                >
                  <li>
                    <EllipsisWithTooltip placement="bottom">
                      {row.factorMethod}
                    </EllipsisWithTooltip>
                  </li>
                  <li>
                    {row.factorValue.toLocaleString("en-US", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </li>
                </ul>
              )}
            </div>
          );
        },
      },
      {
        dataField: "",
        text: "Comps",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div>
              {(row.type == "item" ||
                row.type == "total" ||
                row.type == "profit") && (
                  <ul>
                    <li>CURRENT</li>
                    <li>LY ACTUAL</li>
                    <li>LY BUDGET</li>
                  </ul>
                )}
            </div>
          );
        },
      },
      ...months.map((item) => ({
        dataField: item.month,
        text: item.name,
        headerAlign: "right",
        align: "right",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div>
              {(row.type == "item" ||
                row.type == "total" ||
                row.type == "profit") && (
                  <ul>
                    <li className="bold">
                      {row[item.month].Current.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </li>
                    <li>
                      {row[item.month].Actual.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </li>
                    <li>
                      {row[item.month].Budget.toLocaleString("en-US", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </li>
                  </ul>
                )}
            </div>
          );
        },
      })),
    ];

    const rowClasses = (row, rowIndex) => {
      let classes = "";

      if (row.type == "group") {
        classes = "heading";
      }
      if (row.type == "subgroup") {
        classes = "sub-heading";
      }
      if (row.type == "item") {
        classes = "list-item";
      }
      if (row.type == "total") {
        classes = "subgroup-total";
      }
      if (row.type == "profit") {
        classes = "group-profit";
      }

      return classes;
    };

    return (
      <div className="department common-leyout">
        <div className="header filter-section"></div>
        <div className="body-sec scroll-area">
          <div className="budget-list pad-16">
            {this.state.filterData.length > 0 && !this.state.istableloader && (
              <BootstrapTable
                keyField="id"
                data={this.state.filterData}
                columns={columns}
                rowClasses={rowClasses}
              />
            )}
            {this.state.istableloader && (
              <ReactPageLoader useas={"reconcile"} />
            )}
          </div>
        </div>
        <div className="footer-sec"></div>
      </div>
    );
  }
}
